module.exports = __webpack_public_path__ + "static/img/logo.86f6a7c2.svg";